/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Label } from '@fluentui/react/lib/Label';
import { Stack } from '@fluentui/react/lib/Stack';
import { CustomizerContext } from '@fluentui/react/lib/Utilities';
import * as React from 'react';

import { getAppHost } from '../../../utilities/TeamsUtils';
import { ColorIconPicker } from '../../common/ColorIconPicker';
import { getFooterStyles, getPageStyles, getTitleStyles } from './TemplateInstanceIconPicker.styles';

export interface TemplateInstanceIconPickerComponentProps {
    onDone?: () => void;
    onCancel?: () => void;
    onIconSelected?: (iconName: string) => void;
    onColorSelected?: (color: string) => void;
    selectedIcon?: string;
    selectedColor?: string;
}

export const TemplateInstanceIconPickerComponent: React.FC<TemplateInstanceIconPickerComponentProps> = (
    props: TemplateInstanceIconPickerComponentProps
): JSX.Element => {
    const theme = React.useContext(CustomizerContext).customizations.settings.theme;
    const loc = getAppHost().getLocale();
    const { onDone, onCancel, onColorSelected, onIconSelected, selectedIcon, selectedColor } = props;

    const colorIconPickerProps = {
        onIconSelected,
        onColorSelected,
        selectedIcon,
        selectedColor,
    };

    return (
        <Stack styles={getPageStyles}>
            <Stack.Item>
                <Label styles={getTitleStyles(theme)}>{loc.strings.change_template_icon_label}</Label>
            </Stack.Item>
            <Stack.Item grow>
                <ColorIconPicker {...colorIconPickerProps} />
            </Stack.Item>
            <Stack.Item>
                <Stack horizontal verticalAlign='center' styles={getFooterStyles}>
                    <PrimaryButton text={loc.strings.done} onClick={onDone} />
                    <DefaultButton text={loc.strings.action_cancel} onClick={onCancel} />
                </Stack>
            </Stack.Item>
        </Stack>
    );
};
